import { RouteLocation } from "vue-router";
import { useBldgStore } from "../store/bldgStore";

// Await the portal load before navigating, matching authGuard. Previously this fired
// tryGetBuildingData without awaiting and called next() immediately, so the component
// mounted before bldgStore.property resolved. BethsLayout then saw a null property with
// isLoading already false and rendered "Not Found. Please check your link and try again."
// Fast connections usually won the race; slower ones (notably iOS in-app WKWebViews)
// regularly lost it.
export default async (to: RouteLocation, from: RouteLocation) => {
  // Try to load building data if this is a new building
  let bldgCode = to.params.bldgCode ?? to.params.sitecode;
  if (bldgCode) {
    bldgCode = (bldgCode as string).trim().toLowerCase();
    const bldgStore = useBldgStore();
    await bldgStore.tryGetBuildingData(bldgCode);
  } else {
    console.warn(
      `bldgCodeGuard> no siteCode in route params for ${to.fullPath}`,
      to.params
    );
  }
  //console.log(" bldgCodeGuard ");
};
